import React from "react";

const DisclaimerPage = () => {
  return (
    // <div className="container my-5">
    //   <div className="row justify-content-center">
    //     <div className="col-md-10 col-lg-8">
    //       {/* Main Header */}
    //       <h1 className="display-4 text-center mb-5">Legal Disclaimers</h1>

    //       {/* Section 1: Private and Confidential */}
    //       <div className="card shadow-sm mb-4 border-primary">
    //         <div className="card-header bg-primary text-white">
    //           <h2 className="h4 mb-0">Private and Confidential Disclaimer</h2>
    //         </div>
    //         <div className="card-body">
    //           <p className="fw-bold text-danger">Authorized Users Only</p>
    //           <p>
    //             The information contained on this website is intended for
    //             authorized users only and may include confidential or
    //             proprietary content. Unauthorized access, use, disclosure,
    //             copying, or distribution of any part of this website or its
    //             contents is strictly prohibited and may be unlawful.
    //           </p>
    //           <div className="alert alert-warning">
    //             By accessing this website, you agree to maintain the
    //             confidentiality of all information provided and to use it solely
    //             for its intended purpose. Any misuse or unauthorized disclosure
    //             of information may result in disciplinary action, legal
    //             proceedings, or both.
    //           </div>
    //           <p className="text-muted small italic">
    //             If you are not an intended or authorized user, you must exit
    //             this website immediately. Do not attempt to access, download, or
    //             share any information contained herein.
    //           </p>
    //           <hr />
    //           <p className="small mb-0">
    //             All trademarks remain the property of their respective owners.
    //           </p>
    //         </div>
    //       </div>

    //       {/* Section 2: Website Disclaimer */}
    //       <div className="card shadow-sm mb-5">
    //         <div className="card-header bg-orange text-white">
    //           <h2 className="h4 mb-0">Website Disclaimer</h2>
    //         </div>
    //         <div className="card-body">
    //           <section className="mb-4">
    //             <h5>General Information</h5>
    //             <p>
    //               The information provided on this website is for general
    //               informational purposes only. While we strive to keep the
    //               content accurate and up to date, we make no representations or
    //               warranties of any kind, express or implied, about the
    //               completeness, accuracy, reliability, suitability, or
    //               availability of the website or the information, products,
    //               services, or related graphics.
    //             </p>
    //           </section>

    //           <section className="mb-4">
    //             <h5>Limitation of Liability</h5>
    //             <p>
    //               In no event will we be liable for any loss or damage,
    //               including without limitation indirect or consequential loss or
    //               damage, or any loss or damage whatsoever arising from loss of
    //               data or profits, arising out of or in connection with the use
    //               of this website.
    //             </p>
    //           </section>

    //           <section className="mb-4">
    //             <h5>External Links</h5>
    //             <p>
    //               Through this website, you may be able to link to other
    //               websites that are not under our control. We have no control
    //               over the nature, content, and availability of those sites. The
    //               inclusion of any links does not necessarily imply a
    //               recommendation or endorse the views expressed within them.
    //             </p>
    //           </section>

    //           <section className="bg-light p-3 rounded">
    //             <h5>Technical Availability</h5>
    //             <p className="mb-0">
    //               Every effort is made to keep the website up and running
    //               smoothly. However, we take no responsibility for, and will not
    //               be liable for, the website being temporarily unavailable due
    //               to technical issues beyond our control.
    //             </p>
    //           </section>
    //         </div>
    //       </div>

    //       {/* Footer Back Button */}
    //       <div className="text-center">
    //         <button
    //           className="btn btn-outline-secondary"
    //           onClick={() => window.history.back()}
    //         >
    //           Return to Previous Page
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className=" d-flex align-items-center justify-content-center flex-column mt-5 mb-5">
      <div className="col-6 text-start" data-aos="zoom-in-up">
        <p className="fs-1 line-height-1 org  mt-2">
          Private and Confidential Disclaimer
        </p>
        <p className="tJustify mt-4">
          The information contained on this website is intended for authorized
          users only and may include confidential or proprietary content.
          Unauthorized access, use, disclosure, copying, or distribution of any
          part of this website or its contents is strictly prohibited and may be
          unlawful.
        </p>
        <p className="tJustify mt-3">
          By accessing this website, you agree to maintain the confidentiality
          of all information provided and to use it solely for its intended
          purpose. Any misuse or unauthorized disclosure of information may
          result in disciplinary action, legal proceedings, or both.
        </p>
        <p className="tJustify mt-3 ">
          If you are not an intended or authorized user, you must exit this
          website immediately. Do not attempt to access, download, or share any
          information contained herein.
        </p>
        <p className="tJustify mt-3 ">
          All trademarks remain the property of their respective owners
        </p>
      </div>
      <div className="col-6 text-start mt-5" data-aos="zoom-in-up">
        <p className="fs-1 line-height-1 org  mt-2">Website Disclaimer</p>
        <p className="tJustify mt-4">
          The information provided on this website is for general informational
          purposes only. While we strive to keep the content accurate and up to
          date, we make no representations or warranties of any kind, express or
          implied, about the completeness, accuracy, reliability, suitability,
          or availability of the website or the information, products, services,
          or related graphics contained on the website for any purpose. Any
          reliance you place on such information is strictly at your own risk.
        </p>
        <p className="tJustify mt-3">
          In no event will we be liable for any loss or damage, including
          without limitation indirect or consequential loss or damage, or any
          loss or damage whatsoever arising from loss of data or profits,
          arising out of or in connection with the use of this website.
        </p>
        <p className="tJustify mt-3 ">
          Through this website, you may be able to link to other websites that
          are not under our control. We have no control over the nature,
          content, and availability of those sites. The inclusion of any links
          does not necessarily imply a recommendation or endorse the views
          expressed within them.
        </p>
        <p className="tJustify mt-3 ">
          Every effort is made to keep the website up and running smoothly.
          However, we take no responsibility for, and will not be liable for,
          the website being temporarily unavailable due to technical issues
          beyond our control.
        </p>
      </div>
    </div>
  );
};

export default DisclaimerPage;
